export const wrapper = {
  '& li:last-of-type': {
    color: 'var(--color-grey90)',
    fontWeight: 500,
    '& a': {
      color: 'inherit'
    }
  },
  '@media screen and (max-width: 992px)': {
    padding: 0,
    display: 'none'
  }
}
